import { getLocationString } from 'components/employee/helpers'
import { ContractLocation } from 'components/employee/interfaces'

export const toEmployeeContractPayload = (contractLocationList: ContractLocation[]) => {
  const locationUnitIds = contractLocationList.map(contractLocation => ({
    locationUnitId: contractLocation.locationUnit.id
  }))

  return { contractLocationList: locationUnitIds }
}

export const toEmployeeFormItemsList = (contractLocationList: ContractLocation[]) =>
  contractLocationList.map(contract => ({
    ...contract,
    text: getLocationString(contract)
  }))
